import React from 'react';
import { HStack, Icon } from '@chakra-ui/react';
import { StarIcon } from '@chakra-ui/icons';

interface RatingProps {
  initialRating?: number;
  onChange?: (rating: number) => void;
  boxSize?: string;
  readOnly?: boolean;
}

const Rating: React.FC<RatingProps> = ({
  initialRating = 4,
  onChange,
  boxSize,
  readOnly = false,
}) => {
  const handleRatingClick = (rating: number) => {
    if (readOnly || !onChange) return;
    onChange(rating);
  };

  return (
    <HStack spacing={2}>
      {[...Array(5)].map((_, index) => {
        const ratingValue = index + 1;
        const isFilled = ratingValue <= initialRating;

        return (
          <Icon
            as={StarIcon}
            key={ratingValue}
            boxSize={boxSize || 5}
            sx={{
              stroke: isFilled ? '#0000' : 'brand.secondary.DEFAULT',
              color: isFilled ? 'brand.secondary.DEFAULT' : '#0000',
            }}
            cursor={readOnly ? 'default' : 'pointer'}
            onClick={() => handleRatingClick(ratingValue)}
          />
        );
      })}
    </HStack>
  );
};

export default Rating;
